import { useEffect, useState } from "react";
import { getAllForms } from "../../services/formService";
import "./TotalGuestCount.css";

const TotalGuestCount = () => {
  const [totalGuests, setTotalGuests] = useState(0);
  const [todayGuests, setTodayGuests] = useState(0);
  const [weeklyGuests, setWeeklyGuests] = useState(0);
  const [monthlyGuests, setMonthlyGuests] = useState(0);
  const [nextMonthsGuests, setNextMonthsGuests] = useState(0);

  useEffect(() => {
    fetchGuestData();
  }, []);

  const fetchGuestData = async () => {
    try {
      const data = await getAllForms();
      const forms = data?.forms || [];

      const now = new Date();
      const startOfToday = new Date(now);
      startOfToday.setHours(0, 0, 0, 0);

      const startOfWeek = new Date(now);
      startOfWeek.setDate(startOfWeek.getDate() - startOfWeek.getDay()); // Start of the current week (Sunday)

      const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1); // First day of the current month

      const startOfNextMonth = new Date(
        now.getFullYear(),
        now.getMonth() + 1,
        1
      ); // First day of next month

      let total = 0,
        todayCount = 0,
        weeklyCount = 0,
        monthlyCount = 0,
        nextMonthsCount = 0;

      forms.forEach((form) => {
        const startDate = new Date(form.startDate);
        const endDate = new Date(form.endDate);
        startDate.setHours(0, 0, 0, 0);
        endDate.setHours(0, 0, 0, 0);

        total += form.guestCount;

        if (startOfToday >= startDate && startOfToday <= endDate) {
          todayCount += form.guestCount;
        }
        if (
          startDate <= new Date(startOfWeek.getTime() + 7 * 86400000) &&
          endDate >= startOfWeek
        ) {
          weeklyCount += form.guestCount;
        }
        if (startDate <= startOfNextMonth && endDate >= startOfMonth) {
          monthlyCount += form.guestCount;
        }
        if (startDate >= startOfNextMonth) {
          nextMonthsCount += form.guestCount;
        }
      });

      setTotalGuests(total);
      setTodayGuests(todayCount);
      setWeeklyGuests(weeklyCount);
      setMonthlyGuests(monthlyCount);
      setNextMonthsGuests(nextMonthsCount);
    } catch (error) {
      console.error("Error fetching guest count:", error);
    }
  };

  return (
    <div className="guest-count-container">
      <h2 className="guest-title">Total Guests: {totalGuests}</h2>
      <div className="guest-details">
        <p className="guest-item today">
          Today: <span>{todayGuests}</span>
        </p>
        <p className="guest-item week">
          This Week: <span>{weeklyGuests}</span>
        </p>
        <p className="guest-item month">
          This Month: <span>{monthlyGuests}</span>
        </p>
        <p className="guest-item next-month">
          Next Months: <span>{nextMonthsGuests}</span>
        </p>
      </div>
    </div>
  );
};

export default TotalGuestCount;
